import { FirebaseError } from "firebase/app"

export const isAuthPopupClosedByUser = (error: unknown) => {
  return error instanceof FirebaseError && (error.code === "auth/popup-closed-by-user" || error.code === "auth/cancelled-popup-request" || error.code === "auth/user-cancelled")
}